import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

type ApiAssetId =
  | { tag: "Ada" }
  | { tag: "NativeToken"; policyId: string; assetName: string };

type ApiAssetValue = {
  asset: ApiAssetId;
  value: number;
};

type WithdrawPayload = {
  value: { assets: ApiAssetValue[] };
  nonce: number;
};

export const useHandleWithdrawRequest = () => {
  return useHandleTransactionRequest<WithdrawPayload>("Withdraw");
};
